import { useAuth } from '../pages/login/OAuth';

const useDeliveryNoteService = () => {
    const { api } = useAuth();

    const getDeliveryNote = (id) =>
        api().get(`/delivery_notes/${id}`);

    const getDeliveryNotes = (params) =>
        api().get('/delivery_notes/', { params });

    return {
        getDeliveryNote,
        getDeliveryNotes,
    };
};

export default useDeliveryNoteService;
